// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__p+a3w","push-left":"MainNavigation_push-left__N+qNa","nav-link":"MainNavigation_nav-link__OBQCA","username":"MainNavigation_username__BtddB"};